export default __webpack_public_path__ + "static/VLE-CARS-1920x800-01-Slider-3-94b5503d2e027bac833258b9f2e08f42.webp";